export const SELECTED_BRAND_KEY = 'selectedBrand';
export const SELECTED_PRODUCT_KEY = 'selectedProduct';
export const PROPERTY_INFO_KEY = 'propertyInfo';
export const INSURANCE_NEEDS_KEY = 'insuranceNeeds';
export const CUSTOMER_DATA_KEY = 'customerData';